import React, { Component } from 'react'

class TimelineLayout extends Component {
	render(){
		let { timelineItems } = this.props
		return(
			<div className="TimelineLayout">
				{timelineItems.map((ti, i) =>
					<div key={ti.reactKey} className="timeline-item">
						<div className="line"/>
						<div className="dot"/>
						<div className="date">{ti.date.format('dddd DD.MM.YYYY')}</div>
						<div className="content">{ti.content}</div>
					</div>
				)}
			</div>
		)
	}
}


export default TimelineLayout



// WEBPACK FOOTER //
// ./src/components/TimelineLayout.js